import React, { useContext, useEffect, useState } from "react";
import CPCard from "../Assets/img/profile/Rectangle 1045.png";
import newCPCard from "../Assets/img/profile/Rectangle 1098.png";
import mainCard from "../Assets/img/profile/image 61 (1).png";
import lock from "../Assets/img/profile/lock.png";
import blogCard from "../Assets/img/Blogs/blogs.png";
import styles from "../Assets/css/overview.module.css";
import { BASE_URL } from "../env";
import { AuthContext } from "../Context/AuthContext";

// image 61 (1).png

function FreeTrial() {
	return <div className={styles.free_trial}>Free Trial</div>;
}

function TrialEnded() {
	return (
		<div className={styles.trial_ended}>
			<img src={lock} alt="" /> Trial Ended
		</div>
	);
}

function OverviewCenter(props) {
	let [classes, setClasses] = useState(false);
	let [trial, setTrial] = useState(false);
	let [data, setData] = useState([]);
	const { token, update_token, set_Id } = useContext(AuthContext);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		// setLogoutDropdown(false);
		if (false == false) {
			fetch(BASE_URL + "/getProfile", {
				headers: {
					authorization: "Bearer " + localStorage.getItem("token"),
				},
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.error) {
						// setFirstName("");
					} else {
						setData(data);
						console.log(data);
						// setLoggedin(true);
						// setId(data.user._id);
						// set_Id(data.user._id);
						// setFirstName(data.user.firstName);
						setIsAdmin(data.user.isAdmin);
						// setNAME(data.user.firstName);
					}
				});
		}
	}, [token]);
	return (
		<div
			style={{ marginBottom: "5%" }}
			className={`col-xl-7 col-lg-7 col-md-6 col-sm-6 ${styles.overview_div}`}
		>
			<h1 className={styles.overview}>Overview</h1>
			<div className={styles.free_masterclass}>
				<div className={`d-flex ${styles.roadmap}`}>
					<div>
						<img src={mainCard} alt="" style={{ width: "200px" }} />
					</div>
					<div className={styles.free_masterclass_text}>
						<h3 className={styles.fm_text}>FREE MASTERCLASS</h3>
						<h3 className={styles.rm_text}>
							ROAD MAP TO CRACK TOP PRODUCT COMPANIES
						</h3>
					</div>
				</div>
			</div>
			{/* <img
        src={blogCard}
        alt=""
        style={{ width: "100%", height: "20%" }}
        className={`img-fluid ${styles.overview_img}`}
      /> */}
			<h4 className={styles.my_courses}>My Courses</h4>

			<div class="row">
				<div class="col-xl-7 col-lg-6 col-md-12 col-sm-12">
					<div className={styles.myCourses}>
						<div className={`d-flex ${styles.myCourses_div}`}>
							<div className={styles.myCourse_img}>
								<img src={newCPCard} alt="" class="img-fluid" />
							</div>
							<div
								className={`flex-grow-1 ${styles.myCourse_name}`}
							>
								<h6 className={styles.course_card_title}>
									Competitive Programming
								</h6>
								<hr className={styles.course_hr} />
								<h4 className={styles.force}>Force</h4>
								{/* {trial?} */}
								<FreeTrial />
								{/* <div className={styles.free_trial}>Free Trial</div> */}
							</div>
						</div>
					</div>

					<div className={styles.myCourses}>
						<div className={`d-flex ${styles.myCourses_div}`}>
							<div>
								<img src={newCPCard} alt="" class="img-fluid" />
							</div>
							<div class={`flex-grow-1 ${styles.myCourse_name}`}>
								<h6 className={styles.course_card_title}>
									Competitive Programming
								</h6>
								<hr className={styles.course_hr} />
								<h4 className={styles.force}>Force</h4>
								{/* <div className={styles.trial_ended}>
                  <img src={lock} alt="" /> Trial Ended
                </div> */}
								<TrialEnded />
							</div>
						</div>
					</div>
				</div>

				{isAdmin ? (
					<>
						{/* <p className={styles.my_courses}>Schedule</p> */}

						<div
							style={{ marginTop: "0%" }}
							class={`col-xl-5 col-lg-6 col-md-12 col-sm-12 ${styles.upcoming_classes_div}`}
						>
							<div
								style={{ width: "20rem" }}
								class={styles.upcoming_classes}
							>
								<h5 class={styles.upcoming}>
									Upcoming Classes
								</h5>
								<div
									class={`d-flex ${styles.class_schedule_div}`}
								>
									<div style={{ whiteSpace: "nowrap" }}>
										<img
											src="./images/Vector1.png"
											alt=""
											class={styles.class_date_icon}
										/>
										27th June
									</div>
									<div style={{ whiteSpace: "nowrap" }}>
										<img
											src="./images/Group 119.png"
											alt=""
											class={styles.class_time_icon}
										/>
										8AM - 10AM
									</div>
									<div>
										<button
											type="submit"
											class={styles.join_sm_btn}
										>
											JOIN
										</button>
									</div>
								</div>

								<h6
									style={{ fontSize: "14px" }}
									class={styles.intro_topic}
								>
									Introduction to merging
								</h6>
								<div
									class={`d-flex ${styles.class_schedule_div1}`}
								>
									<div>
										<img
											src="./images/Vector1.png"
											alt=""
											class={styles.class_date_icon}
										/>
										27th June
									</div>
									<div>
										<img
											src="./images/Group 119.png"
											alt=""
											class={styles.class_time_icon}
										/>
										8AM - 10AM
									</div>
									<div>
										<button
											type="submit"
											class={styles.join_sm1_btn}
										>
											JOIN
										</button>
									</div>
								</div>

								<h6
									style={{ fontSize: "14px" }}
									class={styles.intro_topic}
								>
									Introduction Binary Search
								</h6>
								<div
									class={`d-flex ${styles.class_schedule_div1}`}
								>
									<div>
										<img
											src="./images/Vector1.png"
											alt=""
											class={styles.class_date_icon}
										/>
										27th June
									</div>
									<div>
										<img
											src="./images/Group 119.png"
											alt=""
											class={styles.class_time_icon}
										/>
										8AM - 10AM
									</div>
									<div>
										<button
											type="submit"
											class={styles.join_sm1_btn}
										>
											JOIN
										</button>
									</div>
								</div>

								<h6
									style={{ fontSize: "14px" }}
									class={styles.intro_topic}
								>
									Introduction to sorting
								</h6>
								<div
									class={`d-flex ${styles.class_schedule_div1}`}
								>
									<div>
										<img
											src="./images/Vector1.png"
											alt=""
											class={styles.class_date_icon}
										/>
										27th June
									</div>
									<div>
										<img
											src="./images/Group 119.png"
											alt=""
											class={styles.class_time_icon}
										/>
										8AM - 10AM
									</div>
									<div>
										<button
											type="submit"
											class={styles.join_sm1_btn}
										>
											JOIN
										</button>
									</div>
								</div>
							</div>
						</div>
					</>
				) : (
					<div
						class={`col-xl-5 col-lg-6 col-md-12 col-sm-12 ${styles.masterclass_div}`}
					>
						<div className={styles.masterclass}>
							<div className={styles.masterclass_img}>
								{" "}
								<img src={mainCard} alt="" class="img-fluid" />
							</div>
							<div className={styles.btn_innerdiv}>
								<button
									className={styles.enroll_now_btn}
									type="submit"
								>
									Enroll Now
								</button>
							</div>
						</div>
					</div>
				)}
				{/* <div
          class={`col-xl-5 col-lg-6 col-md-12 col-sm-12 ${styles.masterclass_div}`}
        >
          <div className={styles.masterclass}>
            <div className={styles.masterclass_img}>
              {" "}
              <img src={mainCard} alt="" class="img-fluid" />
            </div>
            <div className={styles.btn_innerdiv}>
              <button className={styles.enroll_now_btn} type="submit">
                Enroll Now
              </button>
            </div>
          </div>
        </div> */}
			</div>
			{/* <div className={styles.my_courses_schedule} style={{ display: "flex" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p className={styles.my_courses}>My Courses</p>
          <div style={{ display: "flex" }} className={styles.myCourses}>
            <img src={newCPCard} alt="" />
            <div>
              <div className={styles.myCourse_name}>
                <h6 className={styles.course_card_title}>
                  Competitive Programming
                </h6>
                <hr className={styles.course_hr} />
                <h4 className={styles.force}>Force</h4>
                <div className={styles.free_trial}>Free Trial</div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex" }} className={styles.myCourses}>
            <img src={newCPCard} alt="" />
            <div>
              <div className={styles.myCourse_name}>
                <h6 className={styles.course_card_title}>
                  Competitive Programming
                </h6>
                <hr className={styles.course_hr} />
                <h4 className={styles.force}>Force</h4>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "5%",
          }}
        >
          <p className={styles.my_courses}>Schedule</p>

          <div
          class={`col-xl-6 col-lg-6 col-md-6 col-sm-6 ${styles.upcoming_classes_div}`}
          >
            <div style={{ width: "20rem" }} class={styles.upcoming_classes}>
              <h5 class={styles.upcoming}>Upcoming Classes</h5>
              <div class={`d-flex ${styles.class_schedule_div}`}>
                <div style={{ whiteSpace: "nowrap" }}>
                  <img
                    src="./images/Vector1.png"
                    alt=""
                    class={styles.class_date_icon}
                  />
                  27th June
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                  <img
                    src="./images/Group 119.png"
                    alt=""
                    class={styles.class_time_icon}
                  />
                  8AM - 10AM
                </div>
                <div>
                  <button type="submit" class={styles.join_sm_btn}>
                    JOIN
                  </button>
                </div>
              </div>

              <h6 style={{ fontSize: "14px" }} class={styles.intro_topic}>
                Introduction to merging
              </h6>
              <div class={`d-flex ${styles.class_schedule_div1}`}>
                <div>
                  <img
                    src="./images/Vector1.png"
                    alt=""
                    class={styles.class_date_icon}
                  />
                  27th June
                </div>
                <div>
                  <img
                    src="./images/Group 119.png"
                    alt=""
                    class={styles.class_time_icon}
                  />
                  8AM - 10AM
                </div>
                <div>
                  <button type="submit" class={styles.join_sm1_btn}>
                    JOIN
                  </button>
                </div>
              </div>

              <h6 style={{ fontSize: "14px" }} class={styles.intro_topic}>
                Introduction Binary Search
              </h6>
              <div class={`d-flex ${styles.class_schedule_div1}`}>
                <div>
                  <img
                    src="./images/Vector1.png"
                    alt=""
                    class={styles.class_date_icon}
                  />
                  27th June
                </div>
                <div>
                  <img
                    src="./images/Group 119.png"
                    alt=""
                    class={styles.class_time_icon}
                  />
                  8AM - 10AM
                </div>
                <div>
                  <button type="submit" class={styles.join_sm1_btn}>
                    JOIN
                  </button>
                </div>
              </div>

              <h6 style={{ fontSize: "14px" }} class={styles.intro_topic}>
                Introduction to sorting
              </h6>
              <div class={`d-flex ${styles.class_schedule_div1}`}>
                <div>
                  <img
                    src="./images/Vector1.png"
                    alt=""
                    class={styles.class_date_icon}
                  />
                  27th June
                </div>
                <div>
                  <img
                    src="./images/Group 119.png"
                    alt=""
                    class={styles.class_time_icon}
                  />
                  8AM - 10AM
                </div>
                <div>
                  <button type="submit" class={styles.join_sm1_btn}>
                    JOIN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
		</div>
	);
}

export default OverviewCenter;
